<template>
	<!-- 個人資訊 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>個人資訊</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 帳號資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">帳號資訊</div>
			<div class="deal_content div_hight">
				<el-row>
					<el-col :span="6" :xs="12">
						<div class="grid-content  list_high">登入帳號ID：<span>{{uid}}</span></div>
					</el-col>
					<el-col :span="6" :xs="12">
						<div class="grid-content  list_high">帳號角色：<span>administrator</span></div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6" :xs="12">
						<div class="grid-content  list_high">申請時間：<span>{{joindate}}</span></div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content  list_high">最近一次登錄時間：<span>{{starttime}}</span>
							<el-button type="danger" class="btn_lits" @click="goLoginoperate()">查看登入記錄</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 最高權限管理員資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">最高權限管理員資訊</div>
			<div class="deal_content div_hight">
				<el-row>
					<el-col :span="6" :xs="8">
						<div class="grid-content  list_high">姓名：<span>{{name}}</span></div>
					</el-col>
					<el-col :span="6" :xs="12">
						<div class="grid-content  list_high">綁定手機：<span>{{tel}}</span>
							<el-button type="danger" class="btn_lits" @click="goLoginbh()">申請更改</el-button>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<div class="grid-content  list_high">綁定信箱：<span>{{mailbox}}</span>
							<el-button type="danger" class="btn_lits" @click="goLoginbr()">申請更改</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 安全資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">安全資訊</div>
			<div class="deal_content div_hight_end">
				<div class="grid-content  list_high">登入密碼：
					<el-button type="danger" class="btn_lits" @click="goLoginap()">申請更改</el-button>
				</div>
				<div class="grid-content  list_high">交易密碼：
					<el-button type="danger" class="btn_lits" @click="goLoginat()">申請更改</el-button>
				</div>
				<div class="grid-content  list_high ">預留資訊：<span class="span_color">{{this.$store.state.reserved}}</span>
					<el-button type="danger" class="btn_lits" @click="goLoginzx()">申請更改</el-button>
				</div>
				<div class="grid-content  font_high "><span class="span_color">預留資訊是由您設定的一段辨識用文字，用來鑒定網站身份，防止假冒網站騙取資料造成您的損失。</span></div>
				<div class="grid-content  font_high "><span class="span_color">設定完成後將在各大重要頁面顯示。若未看到您設定的預留資訊，代表您進入的網站存在風險，請停止操作，</span></div>
				<div class="grid-content  font_high "><span class="span_color">並回到官網http://www.taiyigou.com.tw修改密碼。未綁定google密碼驗證器，預留資訊將被隱藏部份。</span></div>
			</div>
		</div>
		<!-- deal_index_box -->
	</div>



</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
			metaInfo: {
				title: '台易購-帳戶中心', // set a title
				meta: [{ // set meta
				name: 'keyWords',
				content: '台灣，購物中心，電子商務，電商平台'
				}, {
				name: 'Description',
				content: '台易購是一個電商平台。'
				}]
			},
		data() {
			return {
				uid: '',
				name: '',
				tel: '',
				joindate: '',
				mailbox: '',
				starttime: ''
			}
		},
		methods: {
			goLoginap() {
				this.$router.push('/login/account/loginap')
			},
			goLoginat() {
				this.$router.push('/login/account/forget');
				this.$store.commit('changeFP','/login/account/');
			},
			goLoginoperate() {
				this.$router.push('/login/account/loginao')
			},
			goLoginbh() {
				this.$router.push('/login/account/loginbh')
			},
			goLoginbr() {
				this.$router.push('/login/account/loginbr')
			},
			goLoginzx() {
				this.$router.push('/login/account/loginar')
			},
		},
		created() {
			this.uid=this.$store.state.uid
			axios.get(this.$store.state.axiosPersonalUrl, {
				params: {
					action: 1,
					uid: this.uid,
				}
			}).then((res) => {
				// console.log(res.data);
				this.joindate = res.data.message.joindate;
				this.mailbox = res.data.message.mailbox;
				this.name = res.data.message.name;
				this.tel = res.data.message.tel;
				this.starttime = res.data.message.starttime;
			})
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 交易管理》交易订单 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 100px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}
	

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}

	/* 表单 */
	.table_download {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.table_download span {
		display: inline-block;
		margin: 0 10px;
	}

	/* 表单头 */
	.table_header {
		height: 36px;
		line-height: 36px;
		background: #f2f2f2;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_content {
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_date {
		box-sizing: border-box;
		width: 160px;
		padding-left: 14px;
		padding-right: 10px;
	}

	.table_merchantorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymentorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		min-width: 160px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymenttype {
		box-sizing: border-box;
		width: 98px;
		padding: 0 10px;
		min-width: 77px;
	}

	.table_status {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	.table_money {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	/* .table_content .table_money {
        text-align: right;
    } */
	.table_operation {
		padding: 0 10px;
	}

	.table_operation span {
		margin-right: 10px;
		padding-bottom: 2px;
		border-bottom: 1px solid;
	}

	/* 分页 */
	.table_pagination {
		display: flex;
		margin: 20px;
		justify-content: flex-end;
	}

	/* 个人资讯 */
	.list_high {
		color: #666666;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 13px;
	}

	.font_high {
		color: darkgrey;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 11px;
		text-indent: 6em;
	}

	.div_hight {
		padding-top: 10px;
	}

	.btn_lits {
		padding-top: 0px;
		padding-bottom: 0px;
		padding-left: 7px;
		padding-right: 7px;
		height: 20px;
		border-top-width: 1px;
		margin-top: 9px;
		margin-left: 20px;
		font-size: 11px;
		background: #e73262;
	}

	.div_hight_end {
		padding-top: 10px;

	}
</style>
